import { render, staticRenderFns } from "./ShopCheckout.vue?vue&type=template&id=5bc15323&scoped=true&"
import script from "./ShopCheckout.vue?vue&type=script&lang=js&"
export * from "./ShopCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ShopCheckout.vue?vue&type=style&index=0&id=5bc15323&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc15323",
  null
  
)

export default component.exports